import IconEvent from '@material-ui/icons/Event'
import { cloneElement } from 'react'
import {
  Button,
  Datagrid,
  DateField,
  ExportButton,
  Filter,
  NumberField,
  sanitizeListRestProps,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  useRedirect,
} from 'react-admin'

import { SCHEDULE_SOURCE_CHOICES } from '../../helpers/constants'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import { StatusIconField } from '../Fields'
import CTList from '../List'

const ScheduleFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <SelectInput label="Source" source="source" choices={SCHEDULE_SOURCE_CHOICES} alwaysOn />
  </Filter>
)

const SchedulizeButton = () => {
  const redirect = useRedirect()

  const generate_schedule = () => redirect('/schedules/generate')

  return (
    <Button label="Schedulize" basePath="schedules" onClick={generate_schedule}>
      <IconEvent />
    </Button>
  )
}

const ScheduleActions = ({
  currentSort,
  className,
  resource,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  maxResults,
  total,
  showFilter,
  displayedFilters,
  filters,
  ...rest
}: any) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <SchedulizeButton />
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filterValues={{ ...filterValues, ...permanentFilter }}
      exporter={exporter}
      maxResults={maxResults}
    />
  </TopToolbar>
)

ScheduleActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
}

const getFullNameOrID = (record: any) =>
  record.first_name || record.last_name ? `${record.first_name} ${record.last_name}` : record.id

const ScheduleList = (props: any) => (
  <CTList
    {...props}
    filters={<ScheduleFilter />}
    actions={<ScheduleActions />}
    sort={{ field: 'date_created', order: 'DESC' }}
    filterDefaultValues={{ source: 'OPTIMIZER' }}
  >
    <Datagrid optimized rowClick="show">
      <StatusIconField source="status" />
      <TextField source="id" />
      <CustomReferenceField
        source="driver"
        sortable={false}
        label="Driver"
        baseUrl="/users"
        representationFunction={getFullNameOrID}
      />
      <CustomReferenceField
        source="created_by"
        sortable={false}
        label="Created By"
        baseUrl="/users"
        representationFunction={getFullNameOrID}
      />
      <DateField source="date_created" options={{ timeZoneName: 'short' }} showTime={true} />
      <DateField source="date_start" options={{ timeZoneName: 'short' }} />
      <DateField source="date_end" options={{ timeZoneName: 'short' }} />
      <NumberField source="drive_mi" />
      <NumberField source="on_duty_hours" />
      <NumberField source="revenue" />
      <NumberField source="revenue_per_mile" />
    </Datagrid>
  </CTList>
)

export default ScheduleList
